import { PrimeReactModal } from "@finanedi.es/storybook"
import { isFirstFactura } from "api/Factura.service"
import { isFirstPagare } from "api/Pagare.service"
import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import { MODAL_STYLES } from "constants/primereactStyles"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import autorizarFinanciacion from "../../../../../../assets/autorizarFinanciacion.svg"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ModalAceptarFinanciacion = ({ state }: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const {
    activeCompany: { nif: empresaActivaNif },
  } = useUsuarioEmpresaActiva()
  const cifTemplate = `ModalAceptarFinanciacion${empresaActivaNif}`
  const dataSession = sessionStorage.getItem(cifTemplate)
  const [modalState, setModalState] = useState(true)
  const showModalGet = () => {
    state?.selectedTabFinanciacion &&
      Promise.all([isFirstFactura(), isFirstPagare()]).then((response) => {
        setModalState(response.some((res: boolean) => res))
        response.some((res: boolean) => res) &&
          sessionStorage.setItem(cifTemplate, "true")
      })
  }
  useEffect(() => {
    dataSession === null && showModalGet()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <PrimeReactModal
      visible={!modalState}
      className='tw-w-130 tw-rounded-lg tw-py-6 tw-px-6 tw-bg-white'
      baseZIndex={30}
      ptContext={MODAL_STYLES}
      closable={false}
      footer={
        <button
          type='button'
          className='tw-px-5 tw-py-2 tw-rounded-md tw-cursor-pointer tw-text-base tw-text-simple-10 !tw-bg-primary tw-w-full'
          onClick={() => {
            setModalState(true)
            sessionStorage.setItem(cifTemplate, "true")
          }}
        >
          {t("validaciones.financiable.modal.continueLabel")}
        </button>
      }
    >
      <div className='tw-flex tw-flex-col tw-items-center'>
        <img
          src={autorizarFinanciacion}
          alt='autorizacion logo'
          className='tw-mb-4'
        />
        <h1 className='tw-text-primary tw-text-2xl tw-font-medium'>
          {t("validaciones.financiable.modal.title")}
        </h1>
        <h2 className='tw-text-primary tw-text-lg tw-font-medium tw-mb-2'>
          {t("validaciones.financiable.modal.subTitle")}
        </h2>
        <div className='tw-text-left tw-p-2 tw-text-base'>
          <p className='tw-mb-2'>
            {t("validaciones.financiable.modal.msgFirstPart")}
          </p>
          <p className='tw-mb-2'>
            {t("validaciones.financiable.modal.msgSecondPart")}
          </p>
        </div>
      </div>
    </PrimeReactModal>
  )
}
